module.exports = __webpack_public_path__ + "static/media/tingeeAdvertisement.670fe507.png";